import { useTargetStore } from "../target/targets.store";
import { useIndexStore } from "../index/indices.store";
import { useResourceStore } from "../resource/resources.store";
import type { RelationStartItemType } from "./RelationItem";
import QuadCurve from "./relation_distribution/QuadCurve";
import Line from "./relation_distribution/Line";

/**
 * @param relation
 */
export function getStartItem(relation: {
  startItemType: RelationStartItemType;
  startItemId: number;
}) {
  if (relation.startItemType === "target") {
    return useTargetStore().items[relation.startItemId];
  } else if (relation.startItemType == "resource") {
    return useResourceStore().items[relation.startItemId];
  } else {
    return useIndexStore().items[relation.startItemId];
  }
}
/**
 * @param relation
 */
export function getEndItem(relation: {
  endItemType: string;
  endItemId: number;
}) {
  if (relation.endItemType === "target") {
    return useTargetStore().items[relation.endItemId];
  } else {
    return useResourceStore().items[relation.endItemId];
  }
}

/**
 * Returns the center point of a line, on the line.
 * @param relationLine 
 * @returns 
 */
export function getLineCenter(relationLine: (QuadCurve | Line)[]) {
  if (!relationLine) return { x: 0, y: 0 };
  if (relationLine.length == 0) return { x: 0, y: 0 };

  const lengths = relationLine.map((line) => QuadCurve.getLength(line));
  const totalLength = lengths.reduce((sum, length) => sum + length, 0);
  const halfLength = totalLength / 2;

  let currentLength = 0;
  for (let i = 0; i < relationLine.length; i++) {
    currentLength += lengths[i];
    if (currentLength >= halfLength) {
      const line = relationLine[i];
      const progress = 1 - (currentLength - halfLength) / lengths[i];
      return {
        x: line.start.x + (line.end.x - line.start.x) * progress,
        y: line.start.y + (line.end.y - line.start.y) * progress
      };
    }
  }

  // Fallback: return center of first and last point
  const first = relationLine[0];
  const last = relationLine[relationLine.length - 1];
  return {
    x: (first.start.x + last.end.x) / 2,
    y: (first.start.y + last.end.y) / 2
  };
}